export const authService = {
  login: async (username: string, password: string) => {
    const API_URL =
      (import.meta as any).env?.VITE_API_BASE_URL ||
      "http://127.0.0.1:1501/api";
    const response = await fetch(`${API_URL}/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    });

    console.log(`${API_URL}/auth/login`);

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "خطا در ورود به حساب کاربری");
    }

    return data;
  },
};
